module.exports = __webpack_public_path__ + "media/site/images/products/saas_actionplan-screen3@2x-eed91ef1e07234cea80c24bc2aeb1ad6.png";